
document.addEventListener('DOMContentLoaded', function() {
  const container = document.querySelector('.product__description__content');
  if (!container) return;

  const h3s = Array.from(container.querySelectorAll('h3'));
  if (!h3s.length) return;

  const nodes = Array.from(container.childNodes);
  const groups = [];
  let currentGroup = null;

  nodes.forEach((node) => {
    if (node.nodeType === 1 && node.tagName.toLowerCase() === 'h3') {
      currentGroup = {
        title: node.textContent.trim(),
        content: []
      };
      groups.push(currentGroup);
    } else if (currentGroup) {
      currentGroup.content.push(node.cloneNode(true));
    }
  });

  if (!groups.length) return;

  container.innerHTML = '';

  groups.forEach((group, index) => {
    const details = document.createElement('details');
    details.className = 'pd-acc__item';

    if (index === 0) {
      details.setAttribute('open', '');
    }

    const summary = document.createElement('summary');
    summary.className = 'pd-acc__summary';
    summary.innerHTML = `
      <span class="pd-acc__summary-text">${group.title}</span>
      <span class="pd-acc__arrow" aria-hidden="true">
        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-nav-arrow-down" viewBox="0 0 24 24">
          <path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
        </svg>
      </span>
    `;

    const wrap = document.createElement('div');
    wrap.className = 'pd-acc__content-wrap';
    wrap.style.height = index === 0 ? 'auto' : '0px';

    const content = document.createElement('div');
    content.className = 'pd-acc__content rte';

    group.content.forEach((node) => {
      content.appendChild(node);
    });

    wrap.appendChild(content);
    details.appendChild(summary);
    details.appendChild(wrap);
    container.appendChild(details);
  });

  container.querySelectorAll('.pd-acc__item').forEach((det) => {
    const summary = det.querySelector('.pd-acc__summary');
    const wrap = det.querySelector('.pd-acc__content-wrap');
    if (!summary || !wrap) return;

    summary.addEventListener('click', function(e) {
      e.preventDefault();

      if (det.open) {
        wrap.style.height = wrap.scrollHeight + 'px';

        requestAnimationFrame(() => {
          wrap.style.height = '0px';
        });

        wrap.addEventListener('transitionend', () => {
          det.removeAttribute('open');
        }, { once: true });

      } else {
        det.setAttribute('open', '');
        wrap.style.height = '0px';

        requestAnimationFrame(() => {
          wrap.style.height = wrap.scrollHeight + 'px';
        });

        wrap.addEventListener('transitionend', () => {
          wrap.style.height = 'auto';
        }, { once: true });
      }
    });
  });
});
